import { Button } from '@fukuri-admins/ui/common';
import { PolarAngleAxis, PolarGrid, Radar, RadarChart, ResponsiveContainer } from 'recharts';
import { DATA_POINT_CONFIGS } from '../constants';
import styles from './styles.module.scss';

type ResultKey = (typeof DATA_POINT_CONFIGS)[number]['items'][number]['key'];

type Result = Record<ResultKey, number>;

type Props = {
  result: Result;
  selectedIndex: number;
  onSelectIndex: (index: number) => void;
};

export const StressAssessmentProfilePresentation: React.FC<Props> = ({
  result,
  selectedIndex,
  onSelectIndex,
}) => {
  const selectedConfig = DATA_POINT_CONFIGS[selectedIndex];

  return (
    <div className={styles.container}>
      <div className={styles.header}>
        <h2 className={styles.title}>ストレスプロフィール</h2>
        <div className={styles.buttonGroup}>
          {DATA_POINT_CONFIGS.map((config, index) => (
            <Button
              key={config.chartTitle}
              variant={selectedIndex === index ? 'primary' : 'secondary'}
              size='sm'
              onClick={() => onSelectIndex(index)}
            >
              {config.chartTitle}
            </Button>
          ))}
        </div>
      </div>

      {selectedConfig && (
        <div className={styles.contentWrapper}>
          <div className={styles.radarChartContainer}>
            <ResponsiveContainer width='80%' height={350}>
              <RadarChart
                data={selectedConfig.items.map(item => ({
                  label: item.label,
                  value: result[item.key],
                }))}
              >
                <PolarGrid className={styles.radarGrid} />
                <PolarAngleAxis dataKey='label' tick={{ className: styles.radarLabel }} />
                <Radar
                  dataKey='value'
                  className={styles.radarChart}
                  dot={{ className: styles.radarDot }}
                />
              </RadarChart>
            </ResponsiveContainer>
            <p className={styles.chartNote}>
              ※得点が大きい（レーダーチャートが外側に大きくなる）ほど良好な結果になります。
            </p>
          </div>
          <div className={styles.tableContainer}>
            <table className={styles.table}>
              <thead>
                <tr>
                  <th className={styles.tableHeader}>調査項目</th>
                </tr>
              </thead>
              <tbody>
                {selectedConfig.items.map((item, index) => (
                  <tr key={index}>
                    <td className={styles.tableCell}>
                      <div>{item.label}</div>
                      <div className={styles.tableCellSub}>{item.valueLabel}</div>
                    </td>
                    <td className={styles.tableCell}>{Number(result[item.key])}/5</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      )}
    </div>
  );
};
